import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';

import { BeoExpoTheme } from './app.theme';
import { locale } from './app.locale';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(),
    providePrimeNG({
      translation: locale['sr-RS'],
      ripple: true,
      theme: {
        preset: BeoExpoTheme,
        options: {
          darkModeSelector: '.be-app-dark'
        }
      }
    })
  ],
};
